/**
 * OPS-PHASE1-009 — module ↔ workflow group ↔ expected FONE workflow permissions (V017–V021).
 */
import { WORKFLOW_PERMISSION_KEYS as K } from './workflowPermissionKeys.js';

/**
 * @typedef {object} ModuleWorkflowDef
 * @property {string} workflowGroup canonical t_core_workflow_group.GROUP_CODE
 * @property {string[]} workflowPermissionKeys FONE action permissions for this module desk
 */

/** @type {Record<string, ModuleWorkflowDef>} */
export const MODULE_WORKFLOW = Object.freeze({
  PATIENT_REGISTRATION: {
    workflowGroup: 'FRONT_OFFICE',
    workflowPermissionKeys: [K.PATIENTS],
  },
  PATIENT_TOKEN: {
    workflowGroup: 'FRONT_OFFICE',
    workflowPermissionKeys: [K.PATIENT_TOKEN],
  },
  PATIENT_JOURNEY: {
    workflowGroup: 'FRONT_OFFICE',
    workflowPermissionKeys: [K.PATIENT_JOURNEY],
  },
  DOCTOR_CONSULTATION: {
    workflowGroup: 'CLINICAL_CONSULTATION',
    workflowPermissionKeys: [K.OPD_CONSULTATION, K.CLINICAL_RECOMMENDATIONS, K.CLINICAL_ACTION],
  },
  OP_BILLING_COUNTER: {
    workflowGroup: 'BILLING_COUNTER',
    workflowPermissionKeys: [
      K.BILLING_WORKSPACE,
      K.OP_BILLING_COUNTER,
      K.BILLING_PAYMENT,
      K.REFUND_REQUEST,
      K.PRINT_RECEIPT,
    ],
  },
  PATIENT_BILLING_DUES: {
    workflowGroup: 'BILLING_COUNTER',
    workflowPermissionKeys: [K.PATIENT_BILLING_DUES],
  },
  SHIFT_CONTINUITY: {
    workflowGroup: 'BILLING_COUNTER',
    workflowPermissionKeys: [K.SHIFT_CONTINUITY, K.SHIFT_OPEN, K.SHIFT_CLOSE],
  },
  IP_DISCHARGE: {
    workflowGroup: 'IP_DISCHARGE',
    workflowPermissionKeys: [K.IP_DISCHARGE],
  },
  INPATIENT: {
    // Canonical FONE:INPATIENT (V102). Distinct from IP_DISCHARGE / FONE:IPDISCHARGE.
    workflowGroup: 'INPATIENT',
    workflowPermissionKeys: [K.INPATIENT],
  },
  OPERATIONAL_RECOVERY: {
    workflowGroup: 'OPERATIONS_SUPERVISOR',
    workflowPermissionKeys: [],
  },
  OPERATIONAL_READINESS: {
    workflowGroup: 'OPERATIONS_SUPERVISOR',
    workflowPermissionKeys: [],
  },
  OPERATIONAL_ALERTS: {
    workflowGroup: 'OPERATIONS_SUPERVISOR',
    workflowPermissionKeys: [K.OPERATIONAL_ALERTS, K.PATIENT_JOURNEY],
  },
  REFUND_REVIEW: {
    workflowGroup: 'OPERATIONS_SUPERVISOR',
    workflowPermissionKeys: [K.REFUND_REVIEW, K.OPERATIONAL_ALERTS],
  },
  FINANCE_AUDIT: {
    workflowGroup: 'OPERATIONS_SUPERVISOR',
    workflowPermissionKeys: [K.COUNTER_FINANCE_AUDIT, K.FINANCE_CLOSE, K.SHIFT_RECOVERED_CLOSE],
  },
  BILLING_DISCOUNT_APPROVAL: {
    workflowGroup: 'OPERATIONS_SUPERVISOR',
    workflowPermissionKeys: [K.OPERATIONAL_APPROVALS],
  },
  LAB_COUNTER: {
    workflowGroup: 'LAB_COUNTER',
    workflowPermissionKeys: [
      K.LAB_COUNTER,
      K.LAB_COLLECTION,
      K.LAB_RESULT_ENTRY,
      K.LAB_PRINT_QUEUE,
      K.LAB_ACTION,
    ],
  },
  LAB_VERIFICATION: {
    workflowGroup: 'LAB_VERIFICATION',
    workflowPermissionKeys: [K.LAB_VERIFICATION, K.LAB_ACTION],
  },
  RADIOLOGY_COUNTER: {
    workflowGroup: 'RADIOLOGY_COUNTER',
    workflowPermissionKeys: [
      K.RADIOLOGY_COUNTER,
      K.RADIOLOGY_SCHEDULING,
      K.RADIOLOGY_TECHNICIAN,
      K.RADIOLOGY_REPORT_ENTRY,
      K.RADIOLOGY_PRINT_QUEUE,
      K.RAD_ACTION,
      K.RADIOLOGY_VERIFICATION,
    ],
  },
  PHARMACY_COUNTER: {
    workflowGroup: 'PHARMACY_COUNTER',
    workflowPermissionKeys: [
      K.PHARMACY_COUNTER,
      K.PHARMACY_ISSUE,
      K.PHARMACY_RETURNS,
      K.PHARMACY_PRINT_QUEUE,
      K.PHARMACY_ACTION,
      K.PRINT_RECEIPT,
    ],
  },
});
